/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Merchant
 */
export interface Merchant {
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    merchantSerialNumber: string;
}

export function MerchantFromJSON(json: any): Merchant {
    return MerchantFromJSONTyped(json, false);
}

export function MerchantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Merchant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'merchantSerialNumber': json['merchantSerialNumber'],
    };
}

export function MerchantToJSON(value?: Merchant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'merchantSerialNumber': value.merchantSerialNumber,
    };
}

